export const menuTitle = { title: "PRODUCT STATUS", label: "Product Status" }
  